import React, { useEffect, useState } from "react";
import { useAppSelector } from "../../infra/hooks";
import DTOSSO from "./DTOSSO";
import SSOPresenter from "./SSOPresenter";

const SSOController = () => {
  const isLoading = useAppSelector((state) => state.LoaderSlice.Loading);
  return (
    <div>
      <DTOSSO />
      <SSOPresenter isLoading={isLoading} />
    </div>
  );
};

export default SSOController;
